import React, { Component } from "react";
import SolutionCollection from "./SolutionCollection";
import Loader from "../../Shared/Loader/loader";
import Scrollable from "../../Shared/Edit/Scrollable";
import { CheckForInternalUser } from "../../Helpers/miscellaneous";
import { MsalContext } from "@azure/msal-react";
import PublishingAppToWorkspace from "./PublishingAppToWorkspace";
import CreateProjectDialog from "../Project/CreateProjectDialog";
import { getOrganisationProjects } from "../../../API/Project/project";
import { getLibraryData } from "../../../API/Organization/organization";
import { postMessageToRuntime } from "../../Helpers/Runtime/runtime";
class SolutionLibrary extends Component {

    static contextType = MsalContext

    Solutions = [
        // {
        //     templateName: "Recommended for you",
        // },
        {
            templateName: "Featured",
        },
        {
            templateName: "Super App",
        }
    ];

    ROLES_ALLOWED_TO_CREATE_PROJECT = ["Owner", "Administrator", "Member"];

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            publishingApp: false,
            selectedApp: {},
            Solutions: [{
                templateName: "All Apps",
            }],
            Data: [],
            organizationProjects: [],
            tags: [],
            selectedTemplate: {
                templateName: localStorage.getItem("selectedTemplate") || "Featured",
            },
            showCreateProjectDialog: false,
            showUpgradeDialog: false
        };
    }

    componentDidMount = async () => {
        await this.getData();
    };

    render() {
        if (this.state.loading) {
            return <Loader />;
        }
        if (this.state.publishingApp) {
            return (
                <PublishingAppToWorkspace
                    onCancel={this.toggleHandleCreate}
                    user={this.props.user}
                    organization={this.props.organization}
                    selectedApp={this.state.selectedApp}
                    onCreate={this.props.isShowFromRuntime && this.props.onAppImport}
                    openedInRuntime={this.props.isShowFromRuntime}
                />
            )
        }
        return (
            <div className="container-fluid h-100">
                {
                    this.state.showCreateProjectDialog &&
                    <CreateProjectDialog
                        isShowFromRuntime={this.props.isShowFromRuntime}
                        projects={this.state.organizationProjects}
                        organization={this.props.organization}
                        user={this.props.user}
                        onCancel={this.toggleCreateProjectDialog}
                        onCreate={this.redirectToProject}
                        onClose={this.toggleCreateProjectDialog}
                        onProjectLimitReached={this.toggleUpgradeDialog} />
                }
                <div className="overflow-auto row h-100">
                    <div className="bg-3 col-xl-2 col-md-4 p-0 border-right">
                        <Scrollable>
                            {
                                (
                                    this.ROLES_ALLOWED_TO_CREATE_PROJECT.includes(this.props.userRole) ||
                                    this.ROLES_ALLOWED_TO_CREATE_PROJECT.includes(this.props.userRole.roleType)
                                ) && (
                                <div className="p-3 text-3 big">
                                    <button
                                        onClick={
                                            this.props.isShowFromRuntime ?
                                                this.props.showCreateProjectPage :
                                                this.toggleCreateProjectDialog
                                        }
                                        className="btn btn-primary">
                                        Create your own
                                    </button>
                                </div>
                                )
                            }
                            <div className="p-3 text-3 big">Featured Picks</div>
                            <ul className="p-0 overflow-auto list-group">
                                {this.Solutions.filter(
                                    (o) => o.templateName.trim() !== ""
                                ).map((item, i) => (
                                    <li
                                        onClick={() =>
                                            this.handleTemplate(item)
                                        }
                                        className={`list-group-item pointer ${item.templateName ===
                                            this.state.selectedTemplate
                                                .templateName && " active"
                                            }`}
                                    >
                                        <span className="me-2">
                                            {item.templateName}
                                        </span>
                                        {item.templateName === "Featured" && (
                                            <i className="fas fa-star text-warning"></i>
                                        )}
                                        {item.templateName === "Super App" && (
                                            <i className="fas fa-rocket text-purple"></i>
                                        )}
                                    </li>
                                ))}
                            </ul>
                            <div className="p-3 text-3 big">
                                Explore by Category
                            </div>
                            <ul className="p-0 overflow-auto list-group">
                                {this.state.Solutions.filter(
                                    (o) => o.templateName.trim() !== ""
                                ).map((item, i) => (
                                    <li
                                        onClick={() =>
                                            this.handleTemplate(item)
                                        }
                                        className={`list-group-item pointer ${item.templateName ===
                                            this.state.selectedTemplate
                                                .templateName && " active"
                                            }`}
                                    >
                                        <span className="me-2">
                                            {item.templateName}
                                        </span>
                                        {item.templateName === "Featured" && (
                                            <i className="fas fa-star text-warning"></i>
                                        )}
                                        {item.templateName === "Super App" && (
                                            <i className="fas fa-rocket text-purple"></i>
                                        )}
                                    </li>
                                ))}
                            </ul>
                        </Scrollable>
                    </div>
                    <div className="p-0 col">
                        <SolutionCollection
                            isShowFromRuntime={this.props.isShowFromRuntime}
                            organization={this.props.organization}
                            Data={this.state.Data}
                            user={this.props.user}
                            userRole={this.props.userRole}
                            onCreate={this.handleCreate}
                            selectedTemplate={this.state.selectedTemplate}
                            tags={this.state.tags}
                            onSeeAllClick={this.handleTemplate}
                        />
                    </div>
                </div>
            </div>
        );
    }

    getData = async () => {
        let [response, organizationProjects] = await Promise.all([
            getLibraryData(),
            getOrganisationProjects(this.props.organization._id)
        ]);
        response = response.filter((item) => item.isActive === true);
        if (!CheckForInternalUser(this.props.user.email)) {
            response = response.filter((item) => item.isPublished === true);
        }
        let tags = "";
        for (let items of response) {
            items.SlideshowImages =
                items.SlideshowImages && items.SlideshowImages !== ""
                    ? items.SlideshowImages.split(",")
                    : [];
            items.tags = items.tag.split(",");
            items.TilesImageName = items.TilesImages
                ? items.TilesImages
                : undefined;
            if (items.tag !== "") {
                tags = tags + items.tag + ",";
            }
        }
        tags = tags.substring(0, tags.length - 1);
        tags = tags.split(",");
        tags = tags.sort();
        tags = [...new Set(tags)];
        const Solutions = [{
            templateName: "All Apps",
        }];
        for (let item of tags) {
            Solutions.push({
                templateName: item
            });
        }

        this.setState({
            Data: response,
            Solutions,
            tags,
            loading: false,
            organizationProjects
        });
    };

    handleTemplate = (dataItem) => {
        localStorage.setItem("selectedTemplate", dataItem.templateName)
        this.setState({
            selectedTemplate: dataItem,
        });
    };

    handleCreate = (dataItem) => {
        postMessageToRuntime({
            eventType: "PROJECT_NAME_CHANGED",
            value: dataItem.name
        })
        this.setState({
            publishingApp: !this.state.publishingApp,
            selectedApp: { ...dataItem }
        })
    }

    toggleHandleCreate = () => {
        this.setState({
            selectedApp: {},
            publishingApp: false
        })
    }

    toggleCreateProjectDialog = () => {
        this.setState({
            showCreateProjectDialog: !this.state.showCreateProjectDialog
        })
    }

    redirectToProject = (project) => {
        const { orgName } = this.props.organization;
        const url = `/${orgName}/${project.name}/Entities?showRecommendationPopup=true`;
        this.props.navigate(url);
    }

    toggleUpgradeDialog = () => {
        this.setState({
            showUpgradeDialog: !this.state.showUpgradeDialog
        })
    }
}

export default SolutionLibrary;
